import TravelRuleSearchInput from './TravelRuleSearchInput'

export default TravelRuleSearchInput
